import type { UserPreferencesNotificationsTableProps } from "./user-preferences-notifications-table.type";
import type { NotificationsReferential } from "@/entities/referential/referential-notifications";
import type { TableProps } from "antd";

import { Table, Typography, Space } from "antd";
import { useTranslation } from "react-i18next";

import { UserPreferencesNotificationsSwitch } from "@/modules/user-preferences-notifications/user-preferences-notifications-switch";

const { Title, Text } = Typography;

import "./user-preferences-notifications-table.style.less";

export const UserPreferencesNotificationsTable = ({
  title,
  notifications,
  userPreferencesNotifications,
  onNotificationSettingsChange,
}: UserPreferencesNotificationsTableProps) => {
  const { t } = useTranslation();
  const columns: TableProps<NotificationsReferential>["columns"] = [
    {
      title: <Title level={2}>{title}</Title>,
      dataIndex: "notification",
      width: "55%",
      render: (_, { name, description }) => (
        <Space orientation="vertical" size={0}>
          <Text strong>{name}</Text>
          <Typography.Text type="secondary">{description}</Typography.Text>
        </Space>
      ),
    },
    {
      title: t("user:preferences.notifications.channels.database"),
      dataIndex: "channels",
      align: "center",
      width: "15%",
      render: (_, { slug, channels }) => (
        <UserPreferencesNotificationsSwitch
          channel="database"
          notificationKey={slug}
          defaultChannels={channels}
          userPreferencesNotifications={userPreferencesNotifications}
          onNotificationSettingsChange={onNotificationSettingsChange}
        />
      ),
    },
    {
      title: t("user:preferences.notifications.channels.broadcast"),
      dataIndex: "channels",
      align: "center",
      width: "15%",
      render: (_, { slug, channels }) => (
        <UserPreferencesNotificationsSwitch
          channel="broadcast"
          notificationKey={slug}
          defaultChannels={channels}
          userPreferencesNotifications={userPreferencesNotifications}
          onNotificationSettingsChange={onNotificationSettingsChange}
        />
      ),
    },
    {
      title: t("user:preferences.notifications.channels.mail"),
      dataIndex: "channels",
      align: "center",
      width: "15%",
      render: (_, { slug, channels }) => (
        <UserPreferencesNotificationsSwitch
          channel="mail"
          notificationKey={slug}
          defaultChannels={channels}
          userPreferencesNotifications={userPreferencesNotifications}
          onNotificationSettingsChange={onNotificationSettingsChange}
        />
      ),
    },
  ];

  return (
    <Table
      rowKey="slug"
      className="user-preferences-notifications-table"
      columns={columns}
      dataSource={notifications}
      pagination={false}
      showHeader
    />
  );
};
